import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IMobileUsersModel } from './types';

const mobileUsers: IMobileUsersModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default mobileUsers;
